import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconDownload(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M11.293 15.707a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 12.586V5a1 1 0 1 0-2 0v7.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3ZM5 18a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
